import React from 'react'

const Logo = ({ isAuthenticated }) => {
  const logo = isAuthenticated ?
  	<div className="br-logo">
  	  <a href="/"><span>Sansiri</span></a>
  	</div> : undefined
  return (
  	<div>
      {logo}
    </div>
  )
}

export default Logo





// WEBPACK FOOTER //
// ./src/components/Logo.js